import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import { translate } from 'react-i18next'
import { findUsers } from '../../sources/AdminSource'
import { sendMultipleEmails } from '../../sources/MailSource'
import { Metrics, Fonts } from '../../Themes'
import {
  isElementInArray,
  addOrRemoveObjectFromList,
  numberWithCommas
} from '../../Utils'
import Grid from 'grid-styled'
import AdminNavbar from '../../components/AdminNavbar'
import CardContainer from '../../components/CardContainer'
import ThemeContainer from '../../components/ThemeContainer'
import Avatar from '../../components/Avatar'
import Tag from '../../components/Tag'
import Checkbox from '../../components/Checkbox'
import Modal from '../../components/Modal'
import Textarea from '../../components/Textarea'
import Input from '../../components/Input'
import Button from '../../components/Button'
import CloseIcon from '../../svg-icons/CloseIcon'
import SearchBar from '../../components/SearchBar'
import { maxPrice, maxRooms, maxYield } from '../../Utils/Constants'
import { searchQueryDefault } from '../../Utils/Defaults'

const PageContainer = styled.section`
  height: 100vh;
  overflow: hidden;
  position: relative;
`

const Container = styled.section`
  margin-top: calc(${Metrics.components.adminNavbar}px - 1px);
  .searchbar-container {
    top: calc(${Metrics.components.adminNavbar}px - 1px);
  }
  max-height: calc(
    ${Metrics.components.adminContent} - (${Metrics.components.adminNavbar}px +
          20px)
  );
  overflow-y: scroll;
`

const Title = styled.div`
  ${Fonts.style.Label};
  text-transform: ${props => (props.capitalize ? 'uppercase' : 'none')};
`

const Preference = styled.div`${Fonts.style.Text};`

const CardContainerTitle = styled.div`
  width: 100%;
  .title {
    float: left;
  }
  .select-all {
    float: right;
    cursor: pointer;
  }
`

const User = styled.div`
  border-bottom: ${Metrics.borders.headerBorder};
  height: ${Metrics.components.adminListRow};
  width: 100%;
  display: table;
  ${Fonts.style.Text};
  cursor: pointer;
`

const CustomGrid = styled(Grid)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.medium)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.medium)};
  display: table-cell;
  vertical-align: middle;
  ${props => props.width && `width: ${props.width}px`};
`

const CustomGridContainer = styled(Grid)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.medium)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.medium)};
`

const CustomTag = styled(Tag)`
  margin-right: ${Metrics.margins.small};
`

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.larger};
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

const CustomModal = styled(Modal)`
  .header {
    text-align: left;
    text-transform: capitalize;
  }
  #modal-body {
    max-height: 450px;  
    text-align: left;
    padding: ${Metrics.margins.base};
  }
  .footer {
    padding: ${Metrics.margins.base};
    margin-top: -${Metrics.margins.larger};
    button {
      float: right;
    }
  }
`

const CustomInput = styled(Input)`
  margin-bottom: ${Metrics.margins.base};
`

const EmailUsersContainer = styled.div`
  margin-top: ${Metrics.margins.small};
  margin-bottom: ${Metrics.margins.base};
`

const ModalFooter = styled.div`
  padding: ${Metrics.margins.base};
  margin-top: -${Metrics.margins.larger};
  button {
    float: right;
  }
`

const NoUsers = styled.div`${Fonts.style.Text};`

class AdminUsers extends Component {
  constructor (props) {
    super(props)
    this.state = {
      users: [],
      selectedUsers: [],
      allUsersSelected: false,
      openModal: false,
      emailBody: '',
      emailSubject: '',
      isFetching: false,
      query: R.clone(searchQueryDefault)
    }
    this.retrieveUsers = this.retrieveUsers.bind(this)
    this.selectUser = this.selectUser.bind(this)
    this.selectAllUsers = this.selectAllUsers.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.toogleModal = this.toogleModal.bind(this)
    this.userDetails = this.userDetails.bind(this)
    this.sendEmails = this.sendEmails.bind(this)
    this.updateSettings = this.updateSettings.bind(this)
  }

  componentWillMount () {
    this.retrieveUsers()
  }

  updateSettings (query) {
    this.setState({ query }, () => {
      this.retrieveUsers()
    })
  }

  retrieveUsers () {
    const { users, query } = this.state
    let queryObj = Object.assign({}, query, { state: 'approved' })

    if (queryObj.preferredCategories.length === 0) {
      delete queryObj.preferredCategories
    }

    if (queryObj.preferredCities.length === 0) {
      delete queryObj.preferredCities
    }

    if (queryObj.preferredRegions.length === 0) {
      delete queryObj.preferredRegions
    }

    if (queryObj.preferredCountries.length === 0) {
      delete queryObj.preferredCountries
    }

    if (queryObj.maxInvestment === maxPrice) {
      delete queryObj.maxInvestment
    }

    if (queryObj.maxNoRooms === maxRooms) {
      delete queryObj.maxNoRooms
    }

    if (queryObj.maxYield === maxYield) {
      delete queryObj.maxYield
    }

    findUsers({ query: queryObj, skip: users.length, limit: 30 })
      .then(response => this.setState({ users: response.data.results }))
      .catch(error => console.log(error))
  }

  selectUser (el) {
    const { selectedUsers } = this.state
    this.setState({
      selectedUsers: addOrRemoveObjectFromList(selectedUsers, el)
    })
  }

  selectAllUsers () {
    let { allUsersSelected, users, selectedUsers } = this.state
    if (allUsersSelected) {
      selectedUsers = []
    } else {
      selectedUsers = users
    }
    this.setState({ selectedUsers, allUsersSelected: !allUsersSelected })
  }

  handleChange (event, key) {
    this.setState({ [key]: event.target.value })
  }

  toogleModal () {
    this.setState({ openModal: !this.state.openModal })
  }

  userDetails (id) {
    this.props.router.push(`/admin/users/${id}`)
  }

  sendEmails () {
    const users = this.state.selectedUsers.map(user => user.id)
    this.setState({ isFetching: true }, () => {
      sendMultipleEmails(users, this.state.emailBody, this.state.emailSubject)
        .then(() => {
          this.setState({
            selectedUsers: [],
            allUsersSelected: false,
            openModal: false,
            emailBody: '',
            emailSubject: '',
            isFetching: false
          })
        })
        .catch(err => {
          console.log(err)
          this.setState({
            selectedUsers: [],
            allUsersSelected: false,
            openModal: false,
            emailBody: '',
            emailSubject: '',
            isFetching: false
          })
        })
    })
  }

  render () {
    const { router, t, admin, dropdownLinks } = this.props
    const {
      users,
      selectedUsers,
      openModal,
      emailBody,
      emailSubject,
      isFetching,
      query
    } = this.state

    return (
      <PageContainer>
        <CustomModal
          visible={openModal}
          header={t('Send E-mail')}
          closeAction={this.toogleModal}
          footer={
            <ModalFooter>
              <Button
                disabled={isFetching}
                label={t('Send')}
                onClick={this.sendEmails}
              />
            </ModalFooter>
          }>
          <Title>{t('To')}</Title>
          <EmailUsersContainer>
            {selectedUsers.map((el, index) => {
              return (
                <Tag
                  key={`user-email-${el.email}`}
                  text={`${el.firstName} ${el.lastName}`}
                  icon={<CloseIcon onClick={() => this.selectUser(el)} />}
                />
              )
            })}
          </EmailUsersContainer>
          <CustomInput
            title={t('Subject')}
            handleChange={event => this.handleChange(event, 'emailSubject')}
            email={emailSubject}
            placeholder={t('Insert Subject')}
          />
          <Textarea
            title={t('E-mail')}
            handleChange={event => this.handleChange(event, 'emailBody')}
            value={emailBody}
            placeholder={t('Write your e-mail in here')}
          />
        </CustomModal>
        <AdminNavbar
          fixedSearchBar
          rightSideActions={[
            {
              label: t('Create User'),
              secondary: true,
              onClick: () => router.push('/admin/users/new')
            },
            {
              label: t('Send Email'),
              primary: true,
              onClick: () => this.toogleModal(),
              disabled: selectedUsers.length === 0
            }
          ]}
          admin={admin}
          dropdownLinks={dropdownLinks}
        />
        <Container>
          <SearchBar
            settings={query}
            updateSettings={this.updateSettings}
            isAdminPage
          />
          <CustomThemeContainer>
            <CustomCardContainer
              title={
                <CardContainerTitle>
                  <div className='title'>{t('Users')}</div>
                  <div
                    className='select-all'
                    onClick={() => this.selectAllUsers()}>
                    {t('Select All')}
                  </div>
                </CardContainerTitle>
              }>
              {users && users.length > 0 ? (
                users.map((el, index) => {
                  return (
                    <User
                      key={`user-${el.email}`}
                      onClick={() => this.userDetails(el.id)}>
                      <CustomGrid xs={0.5} noPadLeft noPadRight noPadTop>
                        <CustomGrid noPadLeft noPadTop width={40}>
                          <Checkbox
                            id={`checkbox-${el.email}`}
                            checked={isElementInArray(selectedUsers, el)}
                            className='checkbox'
                            onClick={event => {
                              event.stopPropagation()
                              this.selectUser(el)
                            }}
                          />
                        </CustomGrid>
                        <CustomGrid noPadLeft noPadTop width={90}>
                          <Avatar imageSrc={el.picture} size={90} />
                        </CustomGrid>
                        <CustomGrid noPadLeft noPadRight noPadTop>
                          <Title
                            capitalize>{`${el.firstName} ${el.lastName}`}</Title>
                          <Preference>{el.email}</Preference>
                        </CustomGrid>
                      </CustomGrid>
                      <CustomGrid xs={0.5} noPadLeft noPadRight noPadTop>
                        <CustomGridContainer
                          xs={1 / 3}
                          noPadLeft
                          noPadRight
                          noPadTop>
                          <Title>{t('Number of keys')}</Title>
                          <Preference>
                            {el.minNoRooms}-{el.maxNoRooms}
                          </Preference>
                        </CustomGridContainer>
                        <CustomGridContainer
                          xs={1 / 3}
                          noPadLeft
                          noPadRight
                          noPadTop>
                          <Title>{t('Estimated Yield')}</Title>
                          <Preference>
                            {el.minYield}-{el.maxYield}
                          </Preference>
                        </CustomGridContainer>
                        <CustomGridContainer
                          xs={1 / 3}
                          noPadLeft
                          noPadRight
                          noPadTop>
                          <Title>{t('Price')}</Title>
                          <Preference>
                            {numberWithCommas(el.minInvestment)}-{numberWithCommas(el.maxInvestment)}
                          </Preference>
                        </CustomGridContainer>
                        {el.preferredCategories.length > 0 && (
                          <div style={{ marginTop: Metrics.margins.base }}>
                            {el.preferredCategories.length > 0 &&
                              el.preferredCategories.map((category, index) => {
                                return (
                                  <CustomTag
                                    text={category.name}
                                    key={`tag-${el.email}-${index}`}
                                  />
                                )
                              })}
                          </div>
                        )}
                      </CustomGrid>
                    </User>
                  )
                })
              ) : (
                <NoUsers>{t('There are no users')}</NoUsers>
              )}
            </CustomCardContainer>
          </CustomThemeContainer>
        </Container>
      </PageContainer>
    )
  }
}

AdminUsers.propTypes = {
  admin: PropTypes.object,
  router: PropTypes.object,
  t: PropTypes.func,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'forms', 'admin' ], { wait: true })(
  AdminUsers
)



// WEBPACK FOOTER //
// ./src/pages/AdminUsers/index.js